import React from "react";
import {
  HostScreenWithSummaryQuestionItem as HostScreenWithSummaryQuestionItemCommonUi,
  QuestionItem,
  QuestionType,
} from "@lookiero/sty-psp-quiz-style-profile-common-ui";
import { HostScreenCta, HostScreenOnSuccessFunction } from "../hostScreenCta/HostScreenCta";

interface HostScreenWithSummaryQuestionItemHOCFunctionArgs {
  readonly onSuccess: HostScreenOnSuccessFunction;
}

interface HostScreenWithSummaryQuestionItemHOCFunction {
  (args: HostScreenWithSummaryQuestionItemHOCFunctionArgs): QuestionItem<QuestionType.HOST_SCREEN_WITH_SUMMARY>;
}

const HostScreenWithSummaryQuestionItemHOC: HostScreenWithSummaryQuestionItemHOCFunction =
  ({ onSuccess }) =>
  ({ domain, country, question, level, children, questionParentId, tradename, segment }) => (
    <HostScreenWithSummaryQuestionItemCommonUi
      country={country}
      cta={<HostScreenCta question={question} onSuccess={onSuccess} />}
      domain={domain}
      level={level}
      question={question}
      questionParentId={questionParentId}
      segment={segment}
      tradename={tradename}
    >
      {children}
    </HostScreenWithSummaryQuestionItemCommonUi>
  );

export { HostScreenWithSummaryQuestionItemHOC };
